import React from 'react'
import SVG from 'react-inlinesvg'
import { useNavigate } from 'react-router-dom'
import { Motif } from '../../types/motifs'
import { GeneratorControlButton } from './common'
import { ComponentProps } from 'react'
import routePaths from '../../constants/routePaths'
import { cn } from '../../utils/cn'

export const RemoveIcon = ({ className = '', ...props }: ComponentProps<'div'>) => (
  <div
    className={cn(
      'absolute right-[-8px] top-[-8px] flex size-[26px] cursor-pointer items-center justify-center overflow-hidden rounded-[50%] border border-solid border-borderGrey bg-white text-red xxl:right-[-12px] xxl:top-[-12px] xxl:size-[32px] [&_svg]:absolute',
      className,
    )}
    {...props}
  />
)

interface Props {
  useSpacing?: boolean
  isEmpty: boolean
  isPlusOne: boolean
  index: number
  motif?: Motif
  onRemove: (id: number) => void
}

const MotifListItem = ({ motif, isEmpty, isPlusOne, onRemove }: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (isEmpty) return
    if (isPlusOne) {
      navigate(routePaths.HOME)
      return
    }
  }

  return (
    <GeneratorControlButton empty={isEmpty} onClick={handleClick}>
      {motif && (
        <div
          className="size-full bg-[length:90%] bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${motif.vectorizedUrlXs || motif.vectorizedUrl || ''})`,
          }}
        />
      )}
      {isPlusOne && (
        <span className="font-approach-light text-[19px] text-black70 md:text-[26px] xl:text-[36px]">
          +1
        </span>
      )}
      {motif && (
        <RemoveIcon onClick={() => onRemove(motif.id)}>
          <SVG src="/icons/x_red.svg" width={12} height={12} />
        </RemoveIcon>
      )}
    </GeneratorControlButton>
  )
}

export default MotifListItem
